<script>
import { mapActions } from "vuex";
import Nav from "./Nav.vue";

export default {
  name: "LayoutProperty",
  components: {
    Nav,
  },
  methods: {
    ...mapActions("property", ["updateTemplate"]),

    updateData() {
      if (this.$route.name == "firstCreatePropiedad") {
        const copy = {
          description: "",
          priceNight: "",
          currency: "EUR",
          nombre: "",
          address: "",
          city: "",
          paisName: "",
          pais: "",
          guests: 1,
          bedrooms: 1,
          bathrooms: 1,
          services: [],
        };
        this.updateTemplate(copy);
      }
    },
  },
  mounted() {
    this.updateData();
  },
};
</script>
<template>
  <div class="container-fluid" style="padding-top: 76px; min-height: calc(100vh)">
    <Nav />
    <div class="container-main">
      <router-view></router-view>
    </div>
  </div>
</template>

<style lang="scss" scoped>

.container-fluid {
  background: linear-gradient(
    286.62deg,
    rgb(226 232 243) 7.58%,
    rgb(255, 255, 255) 49%
  );
}
@media (min-width: 1450px) {
  .container-main {
    padding-inline: 13% !important;
  }
}
</style>
